import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'esc-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
